import React from 'react';
import { modalStyles } from 'utils/modalDesignSystem';

const ModalFormField = ({ 
  label, 
  children, 
  fullWidth = false,
  required = false 
}) => {
  return (
    <div style={fullWidth ? modalStyles.fieldFull : modalStyles.field}>
      {label && (
        <label style={modalStyles.label}>
          {label}
          {required && <span style={{ color: '#dc2626', marginLeft: '4px' }}>*</span>}
        </label>
      )}
      {children}
    </div>
  );
};

export default ModalFormField;